// extracted by mini-css-extract-plugin
export default {"container":"EmailSubject_container__dAv1r","subject":"EmailSubject_subject__crUpR","subjectText":"EmailSubject_subjectText__qS1vT"};